import {getEnv} from './env.ts';

const env = getEnv();

// In direct browser-signed auth (this.i wqz7k3mnbp), requests go straight to
// the agent instead of through the HTTPSig-gateway. Resolving the effective
// base URL here means every call site that builds URLs from API_BASE_URL is
// routed correctly without change. When direct-auth is enabled, env validation
// (env.ts superRefine) guarantees AGENT_DIRECT_URL is a valid http(s) URL, so
// the `&& env.AGENT_DIRECT_URL` guard is belt-and-suspenders; the API_BASE_URL
// branch is the gateway (direct-auth disabled) path.
const apiBaseUrl =
  env.DIRECT_AUTH_ENABLED && env.AGENT_DIRECT_URL
    ? env.AGENT_DIRECT_URL
    : env.API_BASE_URL;

const constants = {
  APP_BASENAME: '',
  TELEPHONE_VALIDATION_PATTERN: /^\+(?:[0-9] ?){7,15}[0-9]$/, //  E.164 format,
  DATE_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  ...env,
  API_BASE_URL: apiBaseUrl,
};

export default constants;
